<template>
  <div>
    <el-divider content-position="center"><h1>关于一七科技</h1></el-divider>
    <span>
      重庆一七科技是一家专注于移动端和5G文娱内容研发和解
      决方案的公司。团队与EPIC中国（虚幻引擎官方）、英伟
      达（中国）等知名企业多年来一直保持技术合作关系。2019年团队以
      10年移动端研发积累转战VR，专注于5G VR（一体机）
      文娱产品研发，所打造的《星际战场》《末日余生2》《 星际骑兵》等作品受到HTC
      、华为等大平台认可，并达成
      内容战略合作，持续为这些平台的内容商城提供优质的5G
      VR文娱产品。团队着力提供5G VR集成式解决方案，并成 功打造多个5G
      VR文娱结合的项目案例，是国内少数专注 5G
      VR并拥有多端联通技术和解决方案的研发团队。
    </span>

    <el-divider content-position="center"><h1>公司产品</h1></el-divider>

    <el-row class="row">
      <el-col :xs="18" :sm="12">
        <el-image
          class="left-img"
          :src="require('@/assets/images/获奖1.jpg')"
        ></el-image>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="items">
          <div
            class="item"
            v-for="item in list"
            :key="item.bg"
            @click="toProduct(item.name)"
          >
            <span :class="item.bg">{{ item.text }}</span>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-divider content-position="center"><h1>合作伙伴</h1></el-divider>
    <el-row>
      <el-col style="text-align: center">
        <el-image :src="require('@/assets/images/合作伙伴.png')"></el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  methods: {
    toProduct(name) {
      this.$router.push({ name: name });
    },
  },
  data() {
    return {
      list: [
        {
          text: "VR文娱产品，一体机游戏",
          bg: "bg1",
          name: "product1",
        },
        {
          text: "企业用便携式VR内容定制",
          bg: "bg2",
          name: "product2",
        },
        {
          text: "综合文旅解决方案",
          bg: "bg3",
          name: "product3",
        },
        {
          text: "大型场景写实",
          bg: "bg4",
          name: "product4",
        },
        {
          text: "社会创新",
          bg: "bg5",
          name: "product5",
        },
      ],
    };
  },
};
</script>

<style scoped lang='less'>
.el-divider {
  margin: 40px 0;
}
.bg1 {
  background-color: #fd5253;
}
.bg2 {
  background-color: #149ca8;
}
.bg3 {
  background-color: #7c9c71;
}
.bg4 {
  background-color: #33495f;
}
.bg5 {
  background-color: #ccb361;
}
span {
  color: #999;
}
h1 {
  font-size: 28px;
}
span {
  font-size: 24px;
}

.items {
  // border: 1px solid #000;
  text-align: center;
  .item {
    margin: 16px 0;
    cursor: pointer;
    transition: transform 0.3s linear;

    &:hover {
      transform: scaleX(1.1);
    }
    span {
      color: #fff;
      font-size: 18px;
      line-height: 28px;
      padding: 10px 15px;
      border: 0 none;
      border-radius: 5px;
      box-shadow: 0 7px 0 rgba(0, 0, 0, 0.2);
      // border: 1px solid #000;
    }
    &:nth-child(1) {
      span {
        padding: 10px 30px;
        margin-bottom: -8px;
        display: inline-block;
        // width: 220px;
        // height: 200px;
      }
    }
  }
}

@media screen and(max-width: 768px) {
  .row {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  h1 {
    font-size: 18px;
  }
  span {
    font-size: 14px;
  }
  .el-divider {
    margin: 35px 0;
  }
}

@media screen and (min-width: 1200px) {
  .items {
    margin-top: 25px;
  }
}
@media screen and (min-width: 1300px) {
  .items {
    margin-top: 50px;
  }
}
@media screen and (min-width: 1500px) {
  .items {
    margin-top: 75px;
  }
}
@media screen and (min-width: 2000px) {
  .items {
    margin-top: 100px;
  }
}
</style>